import { Component, Output, Input, NgZone, OnInit } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { UsersService } from '@app/shared/services/users.service';
import { SocietiesService } from '@app/shared/services/societies.service';
declare var UIkit: any;

@Component({
  selector: 'app-find-user',
  templateUrl: './find-user.component.html',
  styleUrls: ['./find-user.component.scss']
})
export class FindUserComponent implements OnInit {

  @Input() showSocietyPicker: boolean = false;

  public user : any = {};
  public loading : boolean = false;
  public userSet : boolean = false;
  public userSearch : string = '';
  public userSelected : number = 0;
  public userOptions : any = [];
  public userDisplay : boolean = false;
  public noResult : boolean = false;
  public _timeout : any = null;

  // Society picker state (super-admin only)
  public societies: any[] = [];
  public selectedSocietyId: number = 0;
  public selectedSocietyName: string = '';

  @Output() changed = new EventEmitter();

  constructor(
    private userService: UsersService,
    private societiesService: SocietiesService,
    private lc: NgZone
  ) {}

  ngOnInit() {
    if (this.showSocietyPicker) {
      this.societiesService.getSocieties().then((res) => {
        this.societies = res || [];
      });
    }
  }

  resetVariables() {
    this.user = {};
    this._timeout = null;
    this.noResult = false;
    this.loading = false;
    this.userSet = false;
    this.userSearch = '';
    this.userSelected = 0;
    this.userOptions = [];
    this.userDisplay = false;
    this.selectedSocietyId = 0;
    this.selectedSocietyName = '';
  }

  onSocietyChange(societyId: number) {
    this.selectedSocietyId = +societyId;
    const found = this.societies.find(s => s.Id === this.selectedSocietyId);
    this.selectedSocietyName = found ? found.Name : '';
    // Clear user selection when society changes
    this.user = {};
    this.userSet = false;
    this.userSearch = '';
    this.userOptions = [];
  }

  sendUser() {
    if (this.showSocietyPicker) {
      this.changed.emit({
        user: this.user,
        societyId: this.selectedSocietyId,
        societyName: this.selectedSocietyName
      });
    } else {
      this.changed.emit(this.user);
    }
    this.resetVariables();
    UIkit.modal('#find-user').hide();
  };

  updateUserOptionList(event) {
    if (this._timeout) {
      window.clearTimeout(this._timeout);
    }
    this._timeout = window.setTimeout(() => {
      this._timeout = null;
      this.lc.run(() => {
        this.userSearch = event;
        this.loading = true;
        this.noResult = false;
        const societyFilter = this.showSocietyPicker && this.selectedSocietyId > 0
          ? this.selectedSocietyId
          : undefined;
        this.userService.updateUsers(1, this.userSearch, societyFilter).then((res) => {
          if (res.length > 0) {
            this.userOptions = res;
          } else {
            this.noResult = true;
          }
          this.loading = false;
        });
      });
    }, 1000);
  }

  setUserSearch(option) {
    this.user = option;
    this.userSet = true;
    this.userSearch = option.FirstName + ' ' + option.LastName;
  }

  toggleSuggestions(shouldDisplay) {
    setTimeout(() => {
      this.userDisplay = shouldDisplay;
    }, 250);
  }

}
